import { formatShortMonthDayYear } from "@clipboard-health/date-time";
import { isDefined } from "@clipboard-health/util-ts";
import { DialogContent, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";
import { DatePickerInputBottomSheet } from "@src/appV2/redesign/DateTime/DatePickerInputBottomSheet";
import { Input, Text, useModalState } from "@src/appV2/redesign/system/ui-components";
import { useCallback } from "react";

import { FOOTER_BUTTON_MIN_WIDTH } from "../constants";

interface DateValidationStepProps {
  selectedDate: Date | undefined;
  onDateChange: (date: Date) => void;
  onSubmit: () => void;
  onBack: () => void;
  isUploading: boolean;
}

export function DateValidationStep(props: DateValidationStepProps) {
  const { selectedDate, onDateChange, onSubmit, onBack, isUploading } = props;

  const modalState = useModalState();

  const handleDateConfirm = useCallback(
    (date: Date) => {
      onDateChange(date);
      modalState.closeModal();
    },
    [onDateChange, modalState]
  );

  return (
    <>
      <DialogContent>
        <Stack spacing={6}>
          <Text variant="h3">What is the test date on your TB test result?</Text>

          <Input
            fullWidth
            readOnly
            disabled={isUploading}
            placeholder="MM/DD/YYYY"
            value={selectedDate ? formatShortMonthDayYear(selectedDate) : ""}
            iconType="chevron-down"
            onClick={() => {
              modalState.openModal();
            }}
          />
        </Stack>
      </DialogContent>

      <DialogFooter withShadow orientation="horizontal">
        <Button
          size="large"
          disabled={isUploading}
          variant="text"
          sx={{ minWidth: FOOTER_BUTTON_MIN_WIDTH }}
          onClick={onBack}
        >
          Back
        </Button>
        <LoadingButton
          size="large"
          variant="contained"
          disabled={!isDefined(selectedDate)}
          isLoading={isUploading}
          sx={{ minWidth: FOOTER_BUTTON_MIN_WIDTH }}
          onClick={onSubmit}
        >
          Next
        </LoadingButton>
      </DialogFooter>

      <DatePickerInputBottomSheet
        disableFuture
        modalState={modalState}
        initialDate={selectedDate}
        onConfirm={handleDateConfirm}
      />
    </>
  );
}
